import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "m-0 h-full",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = {
  class: "flex w-full h-full",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "questionCount" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Question", -1)
const _hoisted_5 = { style: {"font-weight":"700"} }
const _hoisted_6 = { id: "currentQuestion" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"400"} }, "/", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { id: "allQuestions" }, "12", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionRating = _resolveComponent("QuestionRating")!
  const _component_StepperPanel = _resolveComponent("StepperPanel")!
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.activeQuestion - 9), 1),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createVNode(_component_Stepper, {
        linear: "",
        "unstyled:": "",
        true: "",
        "active-step": _ctx.activeSub,
        "onUpdate:activeStep": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSub) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleEnvironmentalHostility')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 10)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "10",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 11)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "11",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 12)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "12",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 13)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "13",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 14)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 4,
                    question: "14",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleEnvironmentalDynamism')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 15)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "15",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 16)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "16",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 17)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "17",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 18)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "18",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleEnvironmentalComplexity')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 19)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "19",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 20)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "20",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 21)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "21",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["active-step"])
    ])
  ]))
}